import { Heading } from "@aprendaagora/simple-react-component-library";
import React from "react";

const MoleculesPage = () => {
  return (
    <div>
      <Heading text="Molecules" tailwind="mb-3" />
      <p className="p-3 border">
        In interfaces, molecules are relatively simple groups of UI elements
        functioning together as a unit. For example, a form label, search input,
        and button can join together to create a search form molecule.
      </p>
    </div>
  );
};

export default MoleculesPage;
